import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPShengenAdmissionData } from "@/src/types/admissionOffice";

const emptyAdmissionState = (): AOPShengenAdmissionData => ({
  currentDate: "",
  fullName: "",
  dateOfBirth: "",
  nationality: "",
  course: "",
  userOffice: "01",
  whose_doc: "",
  title: "",
  need_qr: true,
  duration: "",
  mediumOfInstruction: "",
  coursePrefix: "",
  body: [],
});

const AOPAdmissionLetterShengenLayout = () => {
  const [dataForGeneration, setDataForGeneration] = useState<AOPShengenAdmissionData>(emptyAdmissionState);
  const [bodyForPrev, setBodyForPrev] = useState<AOPShengenAdmissionData>(emptyAdmissionState);
  const [withQR, setWithQR] = useState(true);

  return (
    <div className="container admission-office-page">
      <AOPConfig
        dataForGeneration={dataForGeneration}
        setDataForGeneration={setDataForGeneration}
        setBodyForPrev={setBodyForPrev}
        setWithQRForPreview={setWithQR}
      />
      <AOPPrev bodyForPrev={bodyForPrev} withQR={withQR} />
    </div>
  );
};

export default AOPAdmissionLetterShengenLayout;
